'use strict'

import { combineReducers } from 'redux'

import {
  CURRENCIES_FETCHED,
  RATES_FETCHED,
  IP_INFO_FETCHED,
  LOADING
} from './actions'

const currencyReducer = (
  state = {
    currencies: {}
  },
  action
) => {
  switch (action.type) {
    case CURRENCIES_FETCHED:
      return { ...state, currencies: !action.error ? action.currencies : {} }
    default:
      return state
  }
}

const ratesReducer = (
  state = {
    rates: {}
  },
  action
) => {
  switch (action.type) {
    case RATES_FETCHED:
      return { ...state, rates: !action.error ? action.rates : {} }
    default:
      return state
  }
}

const ipReducer = (
  state = {
    ipInfo: {}
  },
  action
) => {
  switch (action.type) {
    case IP_INFO_FETCHED:
      return { ...state, ipInfo: !action.error ? action.ipInfo : {} }
    default:
      return state
  }
}

const utilsReducer = (
  state = {
    loading: false
  },
  action
) => {
  switch (action.type) {
    case LOADING:
      return { ...state, loading: action.value }
    default:
      return state
  }
}

const rootReducer = combineReducers({
  currencyReducer,
  ratesReducer,
  ipReducer,
  utilsReducer
})

export default rootReducer
